export default __webpack_public_path__ + "static/media/06.4865aa26.jpg";